module.exports = __webpack_public_path__ + "static/img/11.fc4e8a7a.png";